module.exports = __webpack_public_path__ + "static/media/uploadNewsletter.78f3ed86.svg";